import { useRef,  useState } from "react";
import arrow from "../../../common/images/Vector.png";
import "./VentilatorAlarmTableMobileView.scss";
import { ALARM_TYPE_FILTER } from "../../../common/constant/common-constants";
import lung_svg from "../../../common/icons/svg/lungs.svg";
import consolidation_svg from "../../../common/icons/svg/consolidation.svg"
import { convertUTCtoIST } from "../../../common/utils/CommonUtils";
import { getAlarmHeaderMobileView } from "../../../common/constant/common-constants";
import { useClickOutside } from "../../../common/utils/CommonUtils";

export default function VentilatorAlarmTableMobileView({
    tableRef,
    sortedEvents,
    getPriority,
    isLoading,
    selectedTypeFilter,
    handleFilterSelect
}) {

    const [isAlarmOpen, setIsAlarmOpen] = useState(false);
    const dropdownRef = useRef(null);
    useClickOutside(dropdownRef, () => setIsAlarmOpen(false), isAlarmOpen);

    return (
        <div className="alarm-table-container-mobile-view">
            <div className="alarm-table-container-mobile-view-type">
                <div className="dropdown-container" ref={dropdownRef}>
                    <div
                        className="dropdown-trigger"
                        onClick={() => setIsAlarmOpen(!isAlarmOpen)}
                    >
                        <div className="selected-device-wrapper">
                            <div className="dropdown-title">Type</div>
                            <div className="selected-type">
                                {
                                    ALARM_TYPE_FILTER.find(
                                        item => item.name === selectedTypeFilter
                                    )?.label || "All"
                                }
                            </div>
                        </div>

                        <img className="dropdown-arrow" src={arrow} alt="▼" />
                    </div>

                    {isAlarmOpen && (
                        <div className="dropdown-menu">
                            {ALARM_TYPE_FILTER.map((alarm) => (
                                <div
                                    key={alarm.id}
                                    className={`dropdown-item ${selectedTypeFilter === alarm.name ? "selected" : ""
                                        }`}
                                    onClick={() => {
                                        handleFilterSelect(alarm, "MOBILE-VIEW-FILTER",);
                                        setIsAlarmOpen(false);
                                    }}
                                >
                                    {alarm.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

            </div>
            <div className="alarm-table-container-mobile-view-container">
                <div ref={tableRef} className="alarm-table-container-box">
                    <table className="alarm-table">
                        <thead className="sticky">
                            <tr>
                                {getAlarmHeaderMobileView().map(
                                    (col, index) => (
                                        <th key={index} className="alarm-header-mobile">
                                            {col}
                                        </th>
                                    )
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {sortedEvents?.map((row, index) => {
                                if (!row) return null;

                                const createdIST = convertUTCtoIST(row?.observedTime || "");

                                const priorityData = row?.priority
                                    ? getPriority(row.priority)
                                    : { color: "", textColor: "", icon: "" };

                                const bgColor =
                                    row?.status === "active" ? priorityData.color : "#0D0D0D";

                                const textColor =
                                    row?.status === "active" ? priorityData.textColor : "#FFFFFF";

                                return (
                                    <tr key={index} >
                                        {/* PRIORITY */}
                                        <td style={{ backgroundColor: bgColor }}>
                                            <div className="alarm-priority">
                                                {(row?.type ===
                                                    "PHYSIOLOGICAL" ||
                                                    row?.type === "TECHNICAL") &&
                                                    priorityData?.icon && (
                                                        <img
                                                            alt="priority"
                                                            src={
                                                                priorityData.icon
                                                            }
                                                            className="priority"
                                                        />
                                                    )}

                                                {row?.type ===
                                                    "OPERATIONAL" && (
                                                        <img
                                                            alt="priority"
                                                            src={
                                                                row?.category ===
                                                                    "additional_feature"
                                                                    ? lung_svg
                                                                    : consolidation_svg
                                                            }
                                                            className="priority"
                                                        />
                                                    )}
                                            </div>
                                        </td>

                                        {/* ALARM */}
                                        <td
                                            style={{
                                                backgroundColor: bgColor,
                                                color: textColor,
                                            }}
                                        >
                                            {row?.message || "-"}
                                        </td>

                                        {/* Created at */}
                                        <td
                                            style={{
                                                backgroundColor: bgColor,
                                            }}
                                        >
                                            <td className="alarm-datetime" >
                                                <div className="alarm-date" style={{
                                                    color: textColor,
                                                }}>{createdIST.date}</div>
                                                <div className="alarm-time" style={{
                                                    color: textColor,
                                                }}>{createdIST.time}</div>
                                            </td>


                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    {isLoading && (
                        <div className="spinner-container">
                            <div className="spinner"></div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
